import { useTranslation } from 'react-i18next';

const AppointmentCurrentStatus = ({ row, variant = 'badge', size = '' }) => {
    const { t } = useTranslation();

    const getStatusSurface = (status) => {
        switch (status) {
            case 'SCHEDULED':
                return { background: '#ffe6ad', border: '#f1be57', text: '#8b5a00' };
            case 'CONFIRMED':
                return { background: '#d9f7c8', border: '#83d16a', text: '#256c1f' };
            case 'IN_PROGRESS':
                return { background: '#d4ecff', border: '#63b3ff', text: '#14507f' };
            case 'COMPLETED':
                return { background: '#9ca3af', border: '#9ca3af', text: '#1f2937' };
            case 'CANCELED':
                return { background: '#fef3c7', border: '#f59e0b', text: '#92400e' };
            case 'NO_SHOW':
                return { background: '#ffd8d8', border: '#dc3545', text: '#842029' };
            default:
                return { background: '#eef3f7', border: '#bfd0de', text: '#41515e' };
        }
    };
    
    const getStatusInfo = (status) => {
        switch (status) {
            case 'SCHEDULED':
                return {
                    text: t('scheduled')
                };
            case 'CONFIRMED':
                return {
                    text: t('confirmed')
                };
            case 'IN_PROGRESS':
                return {
                    text: t('in_progress')
                };
            case 'COMPLETED':
                return {
                    text: t('completed')
                };
            case 'CANCELED':
                return {
                    text: t('canceled')
                };
            case 'NO_SHOW':
                return {
                    text: t('no_show')
                };
            default:
                return {
                    text: status
                };
        }
    };

    const statusInfo = getStatusInfo(row.appointmentStatus);
    const surface = getStatusSurface(row.appointmentStatus);

    if (variant === 'text') {
        return (
            <span className={`fw-bold ${size}`} style={{ color: surface.text }}>
                {statusInfo.text}
            </span>
        );
    }

    if (variant === 'dot') {
        return (
            <div className="d-flex align-items-center">
                <span 
                    className="badge rounded-circle p-2 me-2"
                    style={{
                        width: '10px',
                        height: '10px',
                        background: surface.background,
                        border: `1px solid ${surface.border}`
                    }}
                ></span>
                <span className={size} style={{ color: surface.text }}>{statusInfo.text}</span>
            </div>
        );
    }

    // Default: badge variant
    return (
        <div>
            <span
                className={`badge ${size}`.trim()}
                style={{
                    background: surface.background,
                    border: `1px solid ${surface.border}`,
                    color: surface.text,
                    fontWeight: 700,
                    boxShadow: 'none'
                }}
            >
                {statusInfo.text}
            </span>
        </div>
    );
};

export default AppointmentCurrentStatus;
